var exports = {
  "kL": "MobileBottomNav.module__container___R3UwcH",
  "oi": "MobileBottomNav.module__navButton___R3UwcH",
  "Mv": "MobileBottomNav.module__navButtonActive___R3UwcH",
  "XA": "MobileBottomNav.module__navButtonInactive___R3UwcH",
  "VK": "MobileBottomNav.module__voiceButton___R3UwcH",
  "Kk": "MobileBottomNav.module__icon___R3UwcH",
  "Pf": "MobileBottomNav.module__label___R3UwcH",
};

module.exports = exports;
